import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Experience.css';
import ExperienceCard from '../components/ExperienceCard';

const experiences = [
    {
        year: 'September 2024 - Present',
        role: 'Visual Basic .NET Developer ',
        company: 'IQ Solutions',
        description: 'Modernized a legacy legal management system by refactoring VB6 into a modular VB.NET architecture, improving stability, scalability, and long-term maintainability. Optimized SQL Server performance and built secure billing, invoicing, and case-tracking modules with role-based access and audit-ready financial reporting.'
    },
    {
        year: 'May 2024 - October 2024',
        role: 'Interaction Designer',
        company: 'Nexuses',
        description: 'Drove user-centered design for healthcare products through interviews, surveys, and usability testing with 50+ participants, shaping personas, journey maps, and product strategy. Collaborated with engineers and product managers to design accessible, privacy-first Figma prototypes that streamlined workflows and increased user engagement by 30%.'
    },
    {
        year: 'January - June 2023',
        role: 'Front End Developer',
        company: 'York University',
        description: 'Developed and deployed a large-scale hackathon platform using Next.js, React, and TypeScript, collaborating with engineers and designers to support registration, participation, and judging for 500+ users. Designed a responsive, accessible UI with Tailwind CSS and Particle.js animations to enhance performance, interactivity, and cross-device consistency.',
    },
    {
        year: 'January - April 2023',
        role: 'Teaching Assistant in Data Structures',
        company: 'York University',
        description: 'Led lab and review sessions for undergraduate computer science courses, offering one-on-one academic support to reinforce core concepts. Assisted with grading, course administration, and in-class engagement to improve learning outcomes.',
    },
    {
        year: 'September 2022 - December 2023',
        role: 'Peer Mentor',
        company: 'York University',
        description: 'Provided academic guidance on study strategies and time management while addressing student concerns through clear, empathetic communication. Collaborated with university staff to design and deliver workshops and resources that supported student success and demonstrated leadership.',
    }
];

const Experience = () => {
    return (
       <div className="experiences px-6 py-12">
            <h2 className="text-3xl font-bold mb-8">Experience</h2>
            
            <div className="experience-list grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                {experiences.map((exp, index) => (
                <ExperienceCard
                    key={index}
                    year={exp.year}
                    role={exp.role}
                    company={exp.company}
                    description={exp.description}
                />
                ))}
            </div>
        </div>

    );
};

export default Experience;